import React, { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CAPSTONE } from '@rsos/constants/appNames';
import { selectUserPermissionsByApp } from '@rsos/sinatra';
import { _911_INFORM, AVIVE, CRG } from '../../constants/spatialLayers';
import useFetchSpatialLayers from '../../hooks/useFetchSpatialLayers';
import canViewSpatialLayers from '../../utils/canViewSpatialLayers';
import MapLayersControl from './MapLayersControl';

/**
 * Check if user has access to spatial layers capabilities
 */

const MapLayersControlContainer = () => {
  const isFetched = useFetchSpatialLayers();

  if (isFetched) {
    return <MapLayersControl />;
  }
  return null;
};

export default MapLayersControlContainer;
